export let fileFormatsAllowedToUpload = [
  '.xlsx'
]
